import React, {lazy, Suspense} from 'react'

const PrayerBooksLandingPageLazy = lazy(() =>
    import('./PrayerBooksLandingPage')
)

const PrayerBooksLandingPage = props => (
    <Suspense fallback={null}>
        <PrayerBooksLandingPageLazy {...props} />
    </Suspense>
)

export default PrayerBooksLandingPage
